(function () {
    "use strict";

    document.addEventListener('click', function (e) {
        // Description see-more trigger
        const seeMore = e.target.closest('.woocommerce-Tabs-panel--description .description-trigger--see-more');
        if (seeMore) {
            const panel = seeMore.closest('.woocommerce-Tabs-panel--description');
            if (panel) {
                const wrapper = panel.querySelector('.product-description-inner');
                if (wrapper) wrapper.classList.remove('cropped');
                const hideBtn = panel.querySelector('.description-trigger--hide');
                if (hideBtn) hideBtn.style.display = 'block';
            }
            seeMore.style.display = 'none';
            return;
        }

        // Description hide trigger
        const hideBtn = e.target.closest('.woocommerce-Tabs-panel--description .description-trigger--hide');
        if (hideBtn) {
            const panel = hideBtn.closest('.woocommerce-Tabs-panel--description');
            if (panel) {
                const wrapper = panel.querySelector('.product-description-inner');
                if (wrapper) wrapper.classList.add('cropped');
                const seeMore = panel.querySelector('.description-trigger--see-more');
                if (seeMore) seeMore.style.display = 'block';
            }
            hideBtn.style.display = 'none';
            return;
        }

        // Run init when the description tab is clicked
        const tabLink = e.target.closest('.wc-tabs li a');
        if (tabLink && tabLink.getAttribute('href') === '#tab-description') {
            setTimeout(init, 100);
        }
    });

    const init = () => {
        const descriptionTrigger = document.querySelector('.woocommerce-Tabs-panel--description .description-trigger--see-more');
        if (!descriptionTrigger) return;
        const panel = descriptionTrigger.closest('.woocommerce-Tabs-panel--description');
        if (!panel) return;
        const wrapper = panel.querySelector('.product-description-inner');
        if (!wrapper) return;

        wrapper.classList.add('cropped');

        if (wrapper.offsetHeight > 0) {
            if (wrapper.offsetHeight >= wrapper.scrollHeight) {
                wrapper.classList.remove('cropped');
                descriptionTrigger.style.display = 'none';
            }
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
